<template>
  <span v-if="user">
    <router-view />
  </span>
</template>

<script>
import GetUserApi from "@/views/panel/user/getUserApi.js";
export default {
  name: "Panel",
  mixins: [GetUserApi],
  components: {  },
  data() {
    return {
      notificationDialog: false,
      notification: null,
      notificationIndex: -1,
    };
  },
  created() {
    this.getUser(() => {
      this.showNextNotification();
    });
  },
  methods: {
    showNextNotification() {
      this.notificationDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
